<template>
  <svg
    width="232"
    height="229"
    viewBox="0 0 232 229"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_3496_43449)">
      <path
        d="M113.171 2.33906C114.334 0.382722 117.166 0.382725 118.329 2.33906L141.585 41.4674C142.314 42.6944 143.806 43.2377 145.154 42.7665L188.12 27.7409C190.268 26.9897 192.438 28.8102 192.071 31.0563L184.735 75.9788C184.505 77.3874 185.299 78.7631 186.634 79.2682L229.206 95.376C231.335 96.1813 231.826 98.9706 230.102 100.455L195.606 130.152C194.524 131.084 194.248 132.648 194.946 133.893L217.205 173.597C218.318 175.582 216.901 178.035 214.626 178.064L169.112 178.64C167.685 178.658 166.468 179.679 166.202 181.081L157.732 225.804C157.308 228.04 154.647 229.008 152.885 227.568L117.649 198.753C116.544 197.85 114.956 197.85 113.851 198.753L78.615 227.568C76.8533 229.008 74.1918 228.04 73.7683 225.804L65.2978 181.081C65.0322 179.679 63.8153 178.658 62.3881 178.64L16.8741 178.064C14.5985 178.035 13.1824 175.582 14.2952 173.597L36.5536 133.893C37.2515 132.648 36.9757 131.084 35.894 130.152L1.39839 100.455C-0.326323 98.9706 0.165507 96.1813 2.29403 95.376L44.8662 79.2682C46.2012 78.7631 46.9954 77.3874 46.7654 75.9788L39.429 31.0563C39.0622 28.8102 41.2319 26.9897 43.3801 27.7409L86.3462 42.7665C87.6935 43.2377 89.1862 42.6944 89.9154 41.4674L113.171 2.33906Z"
        fill="url(#paint0_linear_3496_43449)"
      />
    </g>
    <path
      d="M113.816 2.72225C114.688 1.255 116.812 1.25499 117.684 2.72225L140.94 41.8506C141.851 43.3843 143.717 44.0634 145.401 43.4745L188.367 28.4489C189.979 27.8854 191.606 29.2509 191.331 30.9354L183.994 75.8579C183.707 77.6187 184.7 79.3383 186.368 79.9696L228.941 96.0774C230.537 96.6815 230.906 98.7734 229.612 99.887L195.117 129.584C193.765 130.748 193.42 132.703 194.292 134.26L216.551 173.964C217.385 175.453 216.323 177.292 214.616 177.314L169.102 177.89C167.318 177.912 165.797 179.189 165.465 180.942L156.995 225.664C156.677 227.341 154.681 228.068 153.36 226.987L118.124 198.172C116.743 197.043 114.757 197.043 113.376 198.172L78.1402 226.987C76.8189 228.068 74.8228 227.341 74.5052 225.664L66.0347 180.942C65.7027 179.189 64.1816 177.912 62.3976 177.89L16.8836 177.314C15.1769 177.292 14.1148 175.453 14.9495 173.964L37.2078 134.26C38.0802 132.703 37.7354 130.748 36.3833 129.584L1.88771 99.887C0.594174 98.7734 0.963048 96.6815 2.55944 96.0774L45.1317 79.9696C46.8003 79.3383 47.7931 77.6187 47.5056 75.8579L40.1692 30.9354C39.8941 29.2509 41.5214 27.8854 43.1325 28.4489L86.0986 43.4745C87.7828 44.0634 89.6486 43.3843 90.5602 41.8506L113.816 2.72225Z"
      stroke="url(#paint1_linear_3496_43449)"
      stroke-width="1.5"
    />
    <defs>
      <filter
        id="filter0_i_3496_43449"
        x="0.35498"
        y="0.871582"
        width="230.79"
        height="230.376"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="1.5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_3496_43449"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3496_43449"
        x1="235.75"
        y1="-2"
        x2="-4.25"
        y2="238"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FFCA17" />
        <stop offset="1" stop-color="#977400" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3496_43449"
        x1="235.75"
        y1="-2"
        x2="-4.25"
        y2="238"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#EFEDDB" />
        <stop offset="1" stop-color="#AB8F54" />
      </linearGradient>
    </defs>
  </svg>
</template>
